import { cn } from "@moe/priv/utils";
import { ChatButton } from "@web/components/ChatButton";
import { LikeButton } from "@web/components/LikeButton";
import { ShareButton } from "@web/components/ShareButton";

interface Props {
  size?: "sm" | "md";
  like: {
    likeCount: number;
    isLiked?: boolean;
    onLike?: () => void;
  };
  chat: {
    messageCount: number;
    onChat?: () => void;
  };
  share: {
    onShare?: () => void;
  };
  className?: string;
}
export function CardActionBar({ size = "sm", like, share, chat, className }: Props) {
  return (
    <div
      className={cn(
        "absolute right-2 top-0 flex w-fit flex-col rounded-b-md bg-black/30 px-1.5 py-2 font-semibold",
        className
      )}
    >
      <div className="flex flex-col items-center space-y-4">
        <ChatButton
          size={size}
          layout="vertical"
          messageCount={chat.messageCount}
          onClick={(e) => {
            e.stopPropagation();
            chat.onChat?.();
          }}
        />
        <LikeButton
          color="primary"
          size={size}
          likeCount={like.likeCount}
          isLiked={like.isLiked ?? false}
          onClick={(e) => {
            e.stopPropagation();
            like.onLike?.();
          }}
        />
        <ShareButton
          color="primary"
          size={size}
          onClick={(e) => {
            e.stopPropagation();
            share.onShare?.();
          }}
        />
      </div>
    </div>
  );
}
